export default "__VITE_ASSET__D9aRS6$Z__"